import { render, staticRenderFns } from "./SimuladoModoView.vue?vue&type=template&id=3f50108d&scoped=true"
import script from "./SimuladoModoView.vue?vue&type=script&lang=js"
export * from "./SimuladoModoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50108d",
  null
  
)

export default component.exports